<template>
  <div class="totem-dots-indicator" data-block-interaction>
    <div class="dot dot-1" @click="$emit('update:multiTotem', 0); $emit('update:explodeTotem', 1)" :class="{'selected': explodeTotem === 1}"><div class="dot-internal" /></div>
    <div class="dot dot-2" @click="$emit('update:multiTotem', 0); $emit('update:explodeTotem', 0)" :class="{'selected': multiTotem < 0.5 && explodeTotem === 0}"><div class="dot-internal" /></div>
    <div class="dot dot-3" @click="$emit('update:multiTotem', 1); $emit('update:explodeTotem', 0)" :class="{'selected': multiTotem > 0.5}"><div class="dot-internal" /></div>
  </div>
</template>

<script>
export default {
  name: 'TotemDotsIndicator',

  props: {
    multiTotem: {
      type: Number,
      required: true,
      default: 0
    },
    explodeTotem: {
      type: Number,
      required: true,
      default: 0
    }
  },

  data: function () {
    return {
    }
  },

  mounted: function () {

  },

  beforeDestroy: function () {
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
@import 'variables';



@import 'mixins';;

.dot {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  width: 6px;
  height: 6px;
  padding: 6px;

  .dot-internal {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: none;
    border: 1px solid #b3b3b3;
  
    transition: background 0.3s $ease-in-out-quad;
  }

  &.selected {
    .dot-internal {
      background: #cfcece;
    }
  }
}

.dot-1 {
  top: 0;
}
.dot-2 {
  top: 50%;
}
.dot-3 {
  top: 100%;
}

</style>



// WEBPACK FOOTER //
// src/atoms/TotemDotsIndicator.vue